import React from "react";
import { Typography } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
// component
import { formatDate } from "helper/dateFormat";
import FeedsSkelton from "components/Skelton/PastoralSkelton/FeedsSkelton";
// direct import
import FeedCard from "./FeedCard";
import { limitedColors } from "./helper";

const Feeds = ({
  totalFeeds,
  fetchMyAPI,
  feedCardData,
  loading,
  feedsRef,
  onEventClick,
  handleEvent,
}) => {
  return (
    <>
      <Typography
        style={{
          height: 58,
          display: "flex",
          alignItems: "center",
          fontSize: 18,
        }}
      >
        Feeds
      </Typography>

      <div
        className="event-tasks w-100 events-feed"
        style={{ background: "rgba(243, 246, 249, 0.2)" }}
      >
        <div className="p-2" style={{ background: "white" }}>
          <div className="">
            <div
              className="tasks-body tasks-scroll p-3"
              ref={feedsRef}
              id="feeds-wrapper"
            >
              <div>
                {feedCardData?.length === 0 && !loading && (
                  <h3 className="text-center mt-5">No Data</h3>
                )}
                {loading && feedCardData?.length === 0 ? (
                  <FeedsSkelton length={6} />
                ) : (
                  <>
                    <InfiniteScroll
                      scrollableTarget="feeds-wrapper"
                      dataLength={feedCardData.length}
                      next={fetchMyAPI}
                      hasMore={totalFeeds}
                      loader={<FeedsSkelton length={1} />}
                    >
                      {feedCardData?.map((item, id) => {
                        return (
                          <FeedCard
                            key={item.id}
                            feedAvatar={item.profile_img}
                            name={item.name}
                            firstName={item?.fname}
                            lastName={item.lname}
                            subtitle={item.subtitle ?? item.name}
                            description={item.description}
                            postTime={item.postTime}
                            color={
                              limitedColors[
                                Math.floor(Math.random() * limitedColors.length)
                              ]
                            }
                            background={item.background}
                            status={item.type}
                            date={formatDate({
                              date: item?.ShowDate,
                              formatType: "default",
                            })}
                            changedBy={item?.changed_by}
                            suggestionText={item?.memo}
                            onEventClick={() => onEventClick(item)}
                            handleEvent={() => handleEvent(item)}
                          />
                        );
                      })}
                    </InfiniteScroll>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Feeds;
